
import React, { useEffect, useState } from 'react';
import AssignExecutiveSearch from "./Assign-Executive-Search";
import AssignExecutiveDatatable from "./Assign-Executive-datatable";
import { CustomerReportResponse } from '../../models/all-user/edit-user-model';
import { getCustomerExecutiveAssignments, getCustomerExecutiveList } from '../../services/CustomerExecutives/CustomerExecutivesservice';
import CustomerExecutiveService from '../../services/CustomerExecutives/CustomerExecutivesservice';
import { CustomerExecutiveDTO } from '../../models/CustomerExecutive/CustomerExecutive-model';
import { t } from 'i18next';
import { SortOrder } from 'react-data-table-component';

const assignExecutiveToCustomer = async (customerId: number, executiveId: number) => {
    // console.log(`Assigned executive ${executiveId} to customer ${customerId}`);
};


const AssignExecutivePage: React.FC = () => {
    const [customers, setCustomers] = useState<CustomerExecutiveDTO[]>([]);
    const [filters, setFilters] = useState({sortColumn: 'createdDate',sortDirection: 'desc'});
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isEmptyState, setIsEmptyState] = useState(false);
    const [executiveList, setExecutiveList] = useState<{ id: number; name: string }[]>([]);
    const [sortField, setSortField] = useState("createdDate");
const [sortOrder, setSortOrder] = useState(1);
   
 const fetchCustomerData = async (
    page: number,
    pageSize: number,
    filters: any
): Promise<{ data: CustomerExecutiveDTO[]; totalRecords: number }> => {
    try {

      
        const payload = {  
             pageNumber: page,
             pageSize: pageSize,
             customerId: filters?.customerId ?? null,
             salesExecutiveIds: filters?.salesExecutiveIds ?? null,
             unassignedOnly: filters?.unassignedOnly ?? null,
             startDate: filters?.startDate,
             endDate: filters?.endDate ,
             sortColumn: filters?.sortColumn ?? 'createdDate',
              sortDirection: filters?.sortDirection ?? 'desc'
           
              
        };
        
        const response = await CustomerExecutiveService.getCustomerExecutiveAssignments(payload);
            console.log(" Payload sent to API:", payload);


        console.log("API Customer Executive Assignment response:", response);

        return {
            data: response?.customerExecutiveList || [],
            totalRecords: response?.totalRecords || 0
        };
    } catch (error) {
        console.error("Error loading customer data:", error);
        return { data: [], totalRecords: 0 };
    }
};

const handleSortChange = async (field: string, order: 1 | -1) => {
  setSortField(field);
  setSortOrder(order);

  const updatedFilters = {
    ...filters,
    sortColumn: field,
    sortDirection: order === 1 ? 'asc' : 'desc',
  };
  setFilters(updatedFilters); 
};



const loadCustomers = async () => {
    const res = await fetchCustomerData(pageNumber, pageSize, filters);

    
    const sortedData = (res.data || []).sort((a, b) => {
        const dateA = new Date(a.createdDate || a.createdDate || a.createdDate).getTime();
        const dateB = new Date(b.createdDate || b.createdDate || b.createdDate).getTime();
        return dateB - dateA; 
    });

    setCustomers(sortedData);
    setTotalRecords(res.totalRecords);
    setIsEmptyState(Object.keys(filters).length === 0);
};




    useEffect(() => {
        loadCustomers();
    }, [pageNumber, pageSize, filters]);



    const handleSearch = (searchFilters: any) => {
        setFilters(searchFilters);
       setPageNumber(1); 
       
    };


    
    const handleReset = () => {
        setFilters({sortColumn: 'createdDate',sortDirection: 'desc'});
        setPageNumber(1);
    };

    const handlePageChange = (event: any) => {
        setPageNumber(event.page + 1);
        setPageSize(event.rows);
    };

    const handleAssign = async (customerId: number, executiveId: number) => {
        await assignExecutiveToCustomer(customerId, executiveId);
        loadCustomers(); 
    };



    return (

        <div className="p-3">
            <div className="col-12">                
                <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
                    <h4 className="ml-1 mb-0">{t("Assign Customer Executive")}</h4>
                </div>
            </div>
            <AssignExecutiveSearch
                onSearch={handleSearch}
                onReset={handleReset}
                totalRecords={totalRecords}
                
              
            />
            <AssignExecutiveDatatable
                data={customers}
                pageNumber={pageNumber}
                pageSize={pageSize}
                totalRecords={totalRecords}
                onPageChange={handlePageChange}
                 onSortChange={handleSortChange} 
                onAssign={handleAssign}
             
            />
        </div>
    );
};

export default AssignExecutivePage;
